import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { t } from 'i18next';
import { useState } from 'react';
import { ControllerProps, FieldErrors, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { PhoneCodeFlagInput } from '~components/FormFields/PhoneCodeFlagInput';
import useLogin from '~hooks/useLogin/useLogin';

import { signInWithPhoneNumberValidationSchema } from './validationSchemas';

interface SignInPhoneNumberFormProps {
  onOtpSent: (args: { phone: string; phoneId: string }) => void;
  phone: string;
}

interface SignInWithPhoneNumberDataProps extends yup.InferType<
  typeof signInWithPhoneNumberValidationSchema
> {}

const SignInPhoneNumberForm = ({ onOtpSent, phone }: SignInPhoneNumberFormProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { sendOtpSms } = useLogin();

  const onSubmit = async (data: SignInWithPhoneNumberDataProps) => {
    setIsLoading(true);
    try {
      const response = await sendOtpSms({ phone: data.phoneNumber });
      onOtpSent({ phone: data.phoneNumber, phoneId: response.phone_id });
    } catch {
      // Errors are handled in useLogin.
    } finally {
      setIsLoading(false);
    }
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<SignInWithPhoneNumberDataProps>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(signInWithPhoneNumberValidationSchema),
    defaultValues: { phoneNumber: phone ?? '' },
  });

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      <PhoneCodeFlagInput
        control={control as unknown as ControllerProps['control']}
        errors={errors as unknown as FieldErrors}
        name="phoneNumber"
        label={`${t('form_fields.phone')}`}
      />
      <Button
        fullWidth
        color="inherit"
        sx={{ backgroundColor: 'action.disabledBackground' }}
        variant="contained"
        type="submit"
        loading={isLoading}
      >
        {t('actions.send_sms_login_code')}
      </Button>
    </Box>
  );
};

export default SignInPhoneNumberForm;
